<template>
  <div class="divinemap">
    <!-- <div class="mobile_map_page">
      <img width="100%" src="../assets/img/mobile/map.jpg" alt="" />
    </div> -->
    <!-- ps端 -->
    <div class="pc_map_page">
      <div class="introduce">
        <div style="text-align: center;padding: 50px;">
          <img height="100px" src="../assets/img/divinemap/title.png" alt="" />
        </div>
        <div class="person">
          <div class="item">
            <div>
              <img src="../assets/img/home/photo.png" alt="" />
              <div class="name">总设计：李海平</div>
            </div>
            <div class="text">
              <p>毕业于武汉理工大学</p>
              <p>中国物流学会专家委员</p>
              <p>
                曾就职于华为技术、怡亚通供应链、金蝶软件、平安银行总行等行业顶尖企业
              </p>
              <p>20余家中大型国企、上市公司的董事长顾问</p>
            </div>
          </div>
          <div class="item">
            <div>
              <img src="../assets/img/divinemap/photo.jpg" alt="" />
              <div class="name">总编辑：赖国逵</div>
            </div>
            <div class="text">
              <p>毕业于广东外语外贸大学</p>
              <p>14年物流与供应链行业实战经验</p>
              <p>曾就职于怡亚通供应链、平安银行总行等行业顶尖企业</p>
              <p>30+创新产融供应链方案主设计</p>
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="map-wrap">
          <div class="map">
            <div class="icon">
              <img src="../assets/img/icon/icon_arraow.svg" alt="" />
            </div>
            <div class="item">
              <div class="version">7.0</div>
              <div class="dot-wrap">
                <div class="dot"></div>
              </div>
              <div class="picture">
                <img src="../assets/img/divinemap/map7.png" alt="" />
              </div>
            </div>
            <div class="item">
              <div class="version">6.0</div>
              <div class="dot-wrap">
                <div class="dot"></div>
              </div>
              <div class="picture">
                <img src="../assets/img/divinemap/map6.png" alt="" />
              </div>
            </div>
            <div class="item">
              <div class="version">5.0</div>
              <div class="dot-wrap">
                <div class="dot"></div>
              </div>
              <div class="picture">
                <img src="../assets/img/divinemap/map1.jpg" alt="" />
              </div>
            </div>
            <div class="item">
              <div class="version">4.0</div>
              <div class="dot-wrap">
                <div class="dot"></div>
              </div>
              <div class="picture">
                <img src="../assets/img/divinemap/map2.png" alt="" />
              </div>
            </div>
            <div class="item">
              <div class="version">3.0</div>
              <div class="dot-wrap">
                <div class="dot"></div>
              </div>
              <div class="picture">
                <img src="../assets/img/divinemap/map3.png" alt="" />
              </div>
            </div>
            <div class="item">
              <div class="version">2.0</div>
              <div class="dot-wrap">
                <div class="dot"></div>
              </div>
              <div class="picture">
                <img src="../assets/img/divinemap/map4.png" alt="" />
              </div>
            </div>
            <div class="item">
              <div class="version">1.0</div>
              <div class="dot-wrap">
                <div class="dot"></div>
              </div>
              <div class="picture">
                <img src="../assets/img/divinemap/map5.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'divinemap',
  mounted () {
    // document.querySelector('.mobile_map_page').style.height =
    //   window.innerHeight + 'px'
  }
}
</script>

<style lang="scss" scoped>
.introduce {
  background: url(../assets/img/divinemap/bg.jpg) 0 100%;
  background-size: 100% 100%;
  /* padding: 30px; */
}
.introduce .person {
  max-width: 1000px;
  padding-left: 50px;
  margin: auto;
  color: #fff;
  font-size: 20px;
  line-height: 40px;
}
.introduce .person .item {
  display: flex;
  margin-top: 40px;
}
.introduce .person .item .name {
  width: 200px;
  text-align: center;
  line-height: 40px;
  font-size: 14px;
  font-weight: bold;
}
.introduce .person .item img {
  width: 200px;
  height: 200px;
  border-radius: 4px;
}
.introduce .person .item .text {
  padding: 10px 30px;
  p {
    margin: 0;
  }
}

.map-wrap {
  background: #071689;
  padding: 50px 0 50px 20px;
}
.map {
  box-sizing: border-box;
  max-width: 1040px;
  margin: auto;
  padding: 0 80px;
  box-sizing: border-box;
  border-left: 2px solid #17a8c7;
  position: relative;
}
.map .icon {
  transform: rotate(-90deg);
  position: absolute;
  top: -20px;
  width: 18px;
  height: 18px;
  text-align: center;
  left: -15.5px;
}
.map .icon img {
  width: 100%;
}
.map .item {
  width: 100%;
  position: relative;
  margin-top: 50px;
}
.map .item .version {
  color: #fff;
  position: absolute;
  left: -150px;
  top: 44px;
  font-size: 32px;
}
.map .item .dot-wrap {
  width: 30px;
  height: 30px;
  background: #071689;
  position: absolute;
  left: -96px;
  top: 50px;
  padding: 6px;
}
.map .item .dot {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #17a8c7;
}
.map .item .picture {
  width: 100%;
}
.map .item img {
  width: 100%;
  border-radius: 8px;
}

// .mobile_map_page {
//   display: none;
// }

@media screen and (max-width: 1170px) {
  // .pc_map_page {
  //   display: none;
  // }
  // .mobile_map_page {
  //   display: block;
  //   background: #0db5fe;
  // }
}
</style>



// WEBPACK FOOTER //
// src/views/divinemap.vue